import React, { useState } from 'react';
import Default from 'svg/damage_missing_trims.svg';

import { imageUrl } from '../../utils/imageUrl';

interface IProps {
  className?: string;
  src: string;
  height: number;
  width: number;
  objectFit?: 'cover' | 'contain';
  isImageServer?: boolean;
  alt?: string;
}

export const Image = (props: IProps) => {
  const { className, src, height, width, objectFit, alt = '', isImageServer = true } = props;
  const [isLoaded, setIsLoaded] = useState(false);
  const [isError, onToggleIsError] = useState(false);
  const imageOnError = (event: any) => {
    event.currentTarget.src = Default;
    event.currentTarget.objectFit = 'none';
    onToggleIsError(true);
  };

  return (
    <>
      <img
        className={`${className}${isError ? ' tw-object-none tw-px-4' : ''}`}
        src={imageUrl({ src: `${src}`, height, width, objectFit, isImageServer })}
        alt={alt}
        loading={'lazy'}
        onLoad={() => setIsLoaded(true)}
        onError={imageOnError}
      />
      {!isLoaded && !isError && (
        <img
          className={`${className} tw-absolute tw-top-0 tw-blur-[4px] tw-z-30 tw-animate-breath`}
          src={imageUrl({ src: `${src}`, height: 60, width: 80, objectFit, isImageServer })}
          alt={alt}
          onError={imageOnError}
        />
      )}
    </>
  );
};
